import api from "@/services/api.ts";
import {User, CreateUserDto} from "@/types/User.ts";

const URL = '/users';

// Create User
export const createUser = async (user: CreateUserDto): Promise<User> => {
    try{
        const response = await api.post(URL, user);
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            throw new Error(error.response.data.error);
        }
        throw new Error('Failed to create user');
    }
}

export const getUserById = async (id: number): Promise<User | null> => {
    try {
        const response = await api.get(`${URL}/${id}`);
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.status === 404) {
            return null;
        }
        throw error;
    }
};

// Update User
export const updateUser = async (id: number, user: CreateUserDto): Promise<User> => {
    try {
        const response = await api.put(`${URL}/${id}`, user);
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            throw new Error(error.response.data.error);
        }
        throw new Error('Failed to update user');
    }
}

// Get All users
export const getUsers = async (): Promise<User[]> => {
    const response = await api.get<User[]>(URL);
    return response.data;
};

// Delete User
export const deleteUser = async (id: number): Promise<void> => {
    try{
        await api.delete(`${URL}/${id}`);
    } catch (error) {
        throw new Error('Failed to delete user');
    }
};

export const uploadUserProfileImage = async (
  id: number,
  file: File,
  originalFile?: File | null
): Promise<any> => {
  const formData = new FormData();
  formData.append("file", file);
  if (originalFile) {
    formData.append("original", originalFile);
  }

  try {
    const response = await api.put(`${URL}/${id}/upload-photo`, formData);
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.status === 400) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Failed to upload image");
  }
};
